import { createSlice } from '@reduxjs/toolkit';

const FALLBACK_DATA = {
  bloodSummary: {
    testType: 'Type',
    testDate: '20.05.26',
    resultDate: '21.05.25',
    points: [
      'You have a shortage of X',
      'TYour cholesterol',
      'Problem Y',
      'You have a shortage of X  You have a shortage of X You have a shortage of X  You have a shortage of',
    ],
  },
  lifestyleGoals: [
    'You want to improve your sleep',
    'Your energy can be better',
    'You indicated poor sleeping nights',
  ],
  supplements: [
    {
      id: 1,
      brand: 'Vitals Magnesium',
      description:
        "Magnesium is an essential mineral that supports muscle and nerve function, energy production, bone health, and heart rhythm. It's found in foods like leafy greens, nuts, seeds,.",
      dosage: '2 per day',
      reason: 'You had a score of 0,X',
      qty: 1,
      price: 26.99,
      checked: true,
    },
    {
      id: 2,
      brand: 'Vitals Magnesium',
      description:
        "Magnesium is an essential mineral that supports muscle and nerve function, energy production, bone health, and heart rhythm. It's found in foods like leafy greens, nuts, seeds,.",
      dosage: '2 per day',
      reason: 'You had a score of 0,X',
      qty: 1,
      price: 26.99,
      checked: true,
    },
    {
      id: 3,
      brand: 'Vitals Magnesium',
      description:
        "Magnesium is an essential mineral that supports muscle and nerve function, energy production, bone health, and heart rhythm. It's found in foods like leafy greens, nuts, seeds,.",
      dosage: '2 per day',
      reason: 'You had a score of 0,X',
      qty: 1,
      price: 26.99,
      checked: false,
    },
  ],
};

const initialState = {
  bloodSummary: {
    testType: '',
    testDate: '',
    resultDate: '',
    points: [],
  },
  lifestyleGoals: [],
  supplements: [],
  isApproved: false,
  approvedSupplements: [],
  supPeriodId: '',
  isLoaded: false,
};

const adviceSlice = createSlice({
  name: 'advice',
  initialState,
  reducers: {
    hydrateFromReport(state, action) {
      const report = action.payload || {};
      const header = report.header || {};
      const trimHeader = (v) => String(v ?? '').trim();
      // Always take header from this report — do not fall back to previous
      // hydrate (empty test_date from API must show as '', not last report).
      state.bloodSummary.testType = trimHeader(header.type);
      state.bloodSummary.testDate = trimHeader(header.testDate);
      state.bloodSummary.resultDate = trimHeader(header.resultDate);
      state.isApproved = Boolean(report.isApproved);
      state.approvedSupplements = Array.isArray(report.approvedSupplements)
        ? report.approvedSupplements
        : [];
      state.supPeriodId = report.supPeriodId || '';
      // Always sync list fields from this report — empty arrays must clear prior hydrate.
      state.bloodSummary.points = Array.isArray(report.problems)
        ? report.problems
        : [];
      state.lifestyleGoals = Array.isArray(report.lifestyleGoals)
        ? report.lifestyleGoals
        : [];
      if (Array.isArray(report.supplements) && report.supplements.length > 0) {
        const approvedSet = new Set(
          Array.isArray(state.approvedSupplements)
            ? state.approvedSupplements.map((x) => String(x))
            : []
        );
        state.supplements = report.supplements.map((s, idx) => {
          const id = s.id ?? idx + 1;
          const isItemApproved =
            state.isApproved && approvedSet.has(String(id));
          return {
            id,
            productSku: s.productSku ?? s.product_sku ?? s.sku ?? '',
            productId: s.productId ?? s.product_id ?? null,
            sku: s.productSku ?? s.product_sku ?? s.sku ?? '',
            brand: s.brand ?? '',
            description: s.description ?? '',
            packagingLine: s.packagingLine ?? '',
            webInfo: s.webInfo ?? '',
            image: s.image ?? '',
            dosage: s.dosage ?? '',
            prescription:
              s.prescription && typeof s.prescription === 'object'
                ? {
                    dosage: s.prescription.dosage ?? '',
                    dosage_form:
                      s.prescription.dosage_form ??
                      s.prescription.dosageForm ??
                      '',
                    form: s.prescription.form ?? '',
                    daily_frequency:
                      s.prescription.daily_frequency ??
                      s.prescription.dailyFrequency ??
                      null,
                    number_of_days:
                      s.prescription.number_of_days ??
                      s.prescription.numberOfDays ??
                      null,
                    quantity: s.prescription.quantity ?? null,
                  }
                : null,
            qty: s.qty ?? 1,
            price: Number(s.price) || 0,
            // After approval: only approved items default to checked; others unchecked.
            // Before approval: preserve existing behavior (default checked).
            checked: state.isApproved ? isItemApproved : true,
          };
        });
      } else {
        state.supplements = [];
      }
      state.isLoaded = true;
    },
    toggleChecked(state, action) {
      const id = action.payload;
      const item = state.supplements.find((s) => s.id === id);
      if (item) item.checked = !item.checked;
    },
    setQty(state, action) {
      const { id, qty } = action.payload;
      const item = state.supplements.find((s) => s.id === id);
      if (item) item.qty = qty;
    },
    resetAdvice(state) {
      state.bloodSummary = initialState.bloodSummary;
      state.lifestyleGoals = initialState.lifestyleGoals;
      state.supplements = initialState.supplements;
      state.isApproved = initialState.isApproved;
      state.approvedSupplements = initialState.approvedSupplements;
      state.supPeriodId = initialState.supPeriodId;
      state.isLoaded = false;
    },
    loadFallbackData(state) {
      state.bloodSummary = FALLBACK_DATA.bloodSummary;
      state.lifestyleGoals = FALLBACK_DATA.lifestyleGoals;
      state.supplements = FALLBACK_DATA.supplements;
      state.isLoaded = true;
    },
  },
});

export const {
  hydrateFromReport,
  toggleChecked,
  setQty,
  resetAdvice,
  loadFallbackData,
} = adviceSlice.actions;

export { FALLBACK_DATA };

export default adviceSlice.reducer;
